import { CalculationStrategy } from "../strategy.class";
export class CubicCalculationStrategy extends CalculationStrategy {
    constructor() {
        super();
    }
    calculate(calculationData) {
        return {}
    }
}